import { Pagination } from './../../shared/models/pagination.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateAdapter } from '../../shared/adapters/date-adapter';
import { type User } from '../../shared/models/user.model';
import { withDateAdapter, withDateAdapterPage } from '../../shared/rxjs/with-date-adapter';
import { environment as env } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly endpoint = `${env.baseAPIUrl}/user`;

  private readonly dateFields = ['birthdate', 'createdAt', 'updatedAt', 'deletedAt'];
  private readonly transformDate = withDateAdapter<User>(this.dateFields);
  private readonly transformDatePage = withDateAdapterPage<Pagination<User>>(this.dateFields);

  constructor(private readonly http: HttpClient) { }

  getUserDetails(options: any = {}): Observable<User> {
    let headers = new HttpHeaders();
    if (options?.skipLogout) {
      headers = headers.set('X-Skip-Logout', 'true');
    }
    return this.http.get<User>(`${this.endpoint}/me`, { headers }).pipe(this.transformDate);
  }

  getUserById(userId: string): Observable<User> {
    return this.http.get<User>(`${this.endpoint}/${userId}`).pipe(this.transformDate);
  }

  createUser(user: User): Observable<User> {
    return this.http.post<User>(`${this.endpoint}`, DateAdapter.toAPI(user, this.dateFields)).pipe(this.transformDate);
  }

  paginateUsers(page: number, size: number = 10, filter: string = ''): Observable<Pagination<User>> {
    return this.http.get<Pagination<User>>(`${this.endpoint}?page=${page}&pageSize=${size}&search=${filter}`).pipe(this.transformDatePage);
  }

  updateUser(user: User): Observable<User> {
    return this.http.patch<User>(`${this.endpoint}/${user.id}`, DateAdapter.toAPI(user, this.dateFields)).pipe(this.transformDate);
  }

  deleteUser(userId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${userId}`);
  }

  forgotPassword(email: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/forgot-password`, { email });
  }

  resetPassword(token: string, password: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/reset-password`, { token, password });
  }
}
